/*
 * Pure color resolver for select-tag pills. No Vue deps.
 * resolveTagColor(token|'#hex') -> { bg, fg, dot }
 *   token  -> authored triple
 *   #hex   -> dot = color, bg = ~12% tint over white,
 *             fg = color (darkened toward ink when too light to read)
 *   else   -> neutral
 */
const TOKENS = {
    success: { bg: '#e3f6ec', fg: '#0f8a4d', dot: '#16a34a' },
    warning: { bg: '#fbeedd', fg: '#b45309', dot: '#d97706' },
    danger:  { bg: '#fdecec', fg: '#b4444b', dot: '#dc2626' },
    info:    { bg: '#e0f2fe', fg: '#0369a1', dot: '#0ea5e9' },
    primary: { bg: '#e4eef7', fg: '#1e5274', dot: '#1e5274' },
    neutral: { bg: '#eef2f7', fg: '#64748b', dot: '#94a3b8' },
};

const WHITE = { r: 255, g: 255, b: 255 };
const INK = { r: 17, g: 24, b: 39 };
const LIGHT_THRESHOLD = 150;

function parseHex(value) {
    let h = value.replace('#', '').trim();
    if (h.length === 3) {
        h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    }
    if (h.length !== 6 || /[^0-9a-fA-F]/.test(h)) {
        return null;
    }
    return {
        r: parseInt(h.slice(0, 2), 16),
        g: parseInt(h.slice(2, 4), 16),
        b: parseInt(h.slice(4, 6), 16),
    };
}

function luminance(rgb) {
    return 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
}

function mix(rgb, target, t) {
    return {
        r: rgb.r + (target.r - rgb.r) * t,
        g: rgb.g + (target.g - rgb.g) * t,
        b: rgb.b + (target.b - rgb.b) * t,
    };
}

function toHex(rgb) {
    const c = (v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0');
    return '#' + c(rgb.r) + c(rgb.g) + c(rgb.b);
}

function resolveTagColor(color) {
    if (color === null || color === undefined) {
        return Object.assign({}, TOKENS.neutral);
    }
    const key = ('' + color).trim();
    if (TOKENS[key]) {
        return Object.assign({}, TOKENS[key]);
    }
    const rgb = parseHex(key);
    if (!rgb) {
        return Object.assign({}, TOKENS.neutral);
    }
    let fg = toHex(rgb);
    if (luminance(rgb) > LIGHT_THRESHOLD) {
        fg = toHex(mix(rgb, INK, 0.55));
    }
    return {
        bg: toHex(mix(rgb, WHITE, 0.88)),
        fg: fg,
        dot: toHex(rgb),
    };
}

// 预设语义色 token（供配置 UI 复用，保持单一数据源）
const TAG_COLOR_TOKENS = Object.keys(TOKENS);

export { resolveTagColor, TAG_COLOR_TOKENS };
